export enum MediaType {
  AUDIO = 'audio',
  VIDEO = 'video',
  NONE = 'none',
}

export namespace ConnectyCubeMedia {
  export interface ElementOptions {
    muted?: boolean;
    mirror?: boolean;
  }
  export interface ElementParams {
    elementId?: string;
    options?: ElementOptions;
  }
  export interface DisplayParams extends DisplayMediaStreamOptions, ElementParams {}
  export interface UserParams extends MediaStreamConstraints, ElementParams {}
  export type DeviceIdOrTrackConstraints = MediaTrackConstraints | string;
  export type TrackConstraintsOrDeviceIds = {
    audio?: DeviceIdOrTrackConstraints;
    video?: DeviceIdOrTrackConstraints;
  };
}
